import { Injectable } from '@angular/core';
import { UserOrganizationCreateRequest } from '../models/user.requests';
import { OAuthService } from '../services/oauth.service';
import { HttpInterceptor } from '../../../shared/interceptors/http-interceptor.service';
import { BaseWebService } from '../../../shared/services/base.service';
import { Organizacao } from '../models/organizacao.model';
import { User } from '../models/user.model';
import { APIRoutes } from '../../../shared/constants/api-routes.constant';
import { map } from 'rxjs/operators';

@Injectable()
export class OrganizationService extends BaseWebService<Organizacao> {
  constructor(http: HttpInterceptor, oauthService: OAuthService) {
    super(APIRoutes.ORGANIZACAO, http, oauthService);
  }

  newElement(data: any): Organizacao {
    return new Organizacao(data.id, data.url, data.nome);
  }

  createUserOrganization(user: User, organizacao: Organizacao) {
    let url = this.BASE_URL + this.route;
    let userOrganizationRequest = new UserOrganizationCreateRequest(
      organizacao.url,
      organizacao.name,
      user
    );
    return this.http
      .post(url, userOrganizationRequest, { headers: this.httpHeaders })
      .pipe(map((res: any) => res));
  }
}
